import { Badge, Flex } from "antd";
import { getUnread } from "api/services/MessageService";
import { TUnreadMessageCount } from "api/services/models/message.types";
import { ReactComponent as NotificationsIcon } from "Icons/vuesax/notification.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MessageBadge = () => {
  const [unread, setUnread] = useState<TUnreadMessageCount>({ unread: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    getUnread().then(setUnread);
  }, []);

  const handleClick = () => {
    navigate("/messages");
  };

  if (unread.unread === 0) {
    return <></>;
  }

  return (
    <Flex align="center" style={{ height: "64px" }} onClick={handleClick}>
      <Badge title="Notifications" count={unread.unread} size="small">
        <NotificationsIcon />
      </Badge>
    </Flex>
  );
};

export default MessageBadge;
